import React, { useState } from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import { send } from "emailjs-com";
import { toast } from "react-toastify";

const Form = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
    to_name: "Raul-Catalin",
  });
  const { email, name, message } = formData;
  const onSubmitHandler = async (e) => {
    e.preventDefault();
    send(
      "service_tb7t2if",
      "template_ytek24k",
      formData,
      "user_jYfK0fHla2mNVDnuulq2n"
    )
      .then(() => {
        toast.success("Email has been sent!", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setFormData({ name: "", email: "", message: "" });
      })
      .catch((err) => {
        console.log("there was an error");
      });
  };
  const handleChange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.id]: e.target.value,
    }));
  };
  return (
    <FormStyled id="contact" onSubmit={onSubmitHandler}>
      <h2>Contact me!</h2>
      <div className="container">
        <label htmlFor="name">Name:</label>
        <input
          type="text"
          placeholder="Name..."
          id="name"
          onChange={handleChange}
          value={name}
          required
        />
      </div>
      <div className="container">
        <label htmlFor="email">Email:</label>
        <input
          type="email"
          placeholder="Email..."
          id="email"
          onChange={handleChange}
          value={email}
          required
        />
      </div>
      <div className="container">
        <label htmlFor="message">Message:</label>
        <textarea
          placeholder="Enter your message..."
          id="message"
          cols="30"
          rows="10"
          onChange={handleChange}
          value={message}
          required
        ></textarea>
      </div>

      <button type="submit">Submit </button>
    </FormStyled>
  );
};

export default Form;

const FormStyled = styled(motion.form)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 90%;
  margin: 1rem auto;
  border-radius: 0.4rem;
  color: #1f2858;
  h2 {
    margin: 2rem 0;
  }

  .container {
    width: 60%;
    display: flex;
    justify-content: center;
    margin: 0.5rem 0;
    input {
      flex-basis: 85%;
      border: 1px solid #2a52be;
      border-radius: 0.4rem;
      padding: 0.2rem;
    }
  }
  label {
    flex-basis: 15%;
  }

  textarea {
    border-radius: 0.4rem;
    padding: 0.2rem;
    flex-basis: 85%;
    border: 1px solid #2a52be;
    width: 100%;
  }
  input,
  textarea {
    &:focus {
      outline: none;
    }
  }
  button {
    height: 3rem;
    min-width: 5rem;
    background-color: #2a52be;
    border: none;
    border-radius: 0.4rem;
    color: #fefefe;
    transition: all 0.3s ease;
    cursor: pointer;
    font-size: 1.2rem;
    margin: 1rem 0;
    &:hover {
      color: #2a52be;
      background-color: #fefefe;
      border: 1px solid #2a52be;
    }
  }
  @media only screen and (max-width: 1225px) {
    .container {
      width: 70%;
    }
  }
  @media only screen and (max-width: 1225px) {
    .container {
      width: 85%;
    }
  }
  @media only screen and (max-width: 1225px) {
    .container {
      width: 100%;
      flex-direction: column;
    }
  }
`;
